const financeOptions = [
  {
    "productId": 43,
    "productGuid": "20125e19-f2c2-42f4-a230-ec668f776296",
    "name": "Interest Free Finance (9 Months)",
    "minLoan": 450.0000,
    "maxLoan": 50000.0000,
    "months": 9,
    "monthlyRate": 0.0,
    "apr": 0.0,
    "serviceFee": 0.0,
    "documentFee": 0.0,
    "documentFeeCollectionMonth": 0,
    "documentFeeMaximum": 0,
    "documentFeeMinimum": 0,
    "documentFeePercentage": 0.0,
    "optionPeriod": 0,
    "deferredPeriod": 0,
    "tag": "IFF9",
    "altTag": "ONIF9",
    "settlementFee": 0.0
  },
  {
    "productId": 28,
    "productGuid": "8e0bd3a9-657f-457c-b488-dbfab37fac39",
    "name": "Interest Free Finance (12 Months)",
    "minLoan": 750.0000,
    "maxLoan": 50000.0000,
    "months": 12,
    "monthlyRate": 0.0,
    "apr": 0.0,
    "serviceFee": 0.0,
    "documentFee": 0.0,
    "documentFeeCollectionMonth": 0,
    "documentFeeMaximum": 0,
    "documentFeeMinimum": 0,
    "documentFeePercentage": 0.0,
    "optionPeriod": 0,
    "deferredPeriod": 0,
    "tag": "IFF12",
    "altTag": "ONIF12",
    "settlementFee": 0.0
  },
  {
    "productId": 29,
    "productGuid": "9d6fa148-eeb2-4345-b5c6-961902a8f0eb",
    "name": "Interest Free Finance (24 Months)",
    "minLoan": 1750.0000,
    "maxLoan": 50000.0000,
    "months": 24,
    "monthlyRate": 0.0,
    "apr": 0.0,
    "serviceFee": 0.0,
    "documentFee": 0.0,
    "documentFeeCollectionMonth": 0,
    "documentFeeMaximum": 0,
    "documentFeeMinimum": 0,
    "documentFeePercentage": 0.0,
    "optionPeriod": 0,
    "deferredPeriod": 0,
    "tag": "IFF24",
    "altTag": "IFF24",
    "settlementFee": 0.0
  },
  {
    "productId": 30,
    "productGuid": "e931ab43-b8ae-431d-ac50-812d413fb5bb",
    "name": "Interest Free Finance (36 Months)",
    "minLoan": 4000.0000,
    "maxLoan": 50000.0000,
    "months": 36,
    "monthlyRate": 0.0,
    "apr": 0.0,
    "serviceFee": 0.0,
    "documentFee": 0.0,
    "documentFeeCollectionMonth": 0,
    "documentFeeMaximum": 0,
    "documentFeeMinimum": 0,
    "documentFeePercentage": 0.0,
    "optionPeriod": 0,
    "deferredPeriod": 0,
    "tag": "IFF36",
    "altTag": "IFF36",
    "settlementFee": 0.0
  },
  {
    "productId": 31,
    "productGuid": "E2D7B26B-D494-494A-AA50-A804C52942A0",
    "name": "Interest Free Finance (48 Months)",
    "minLoan": 6000.0000,
    "maxLoan": 50000.0000,
    "months": 48,
    "monthlyRate": 0.0,
    "apr": 0.0,
    "serviceFee": 0.0,
    "documentFee": 0.0,
    "documentFeeCollectionMonth": 0,
    "documentFeeMaximum": 0,
    "documentFeeMinimum": 0,
    "documentFeePercentage": 0.0,
    "optionPeriod": 0,
    "deferredPeriod": 0,
    "tag": "IFF48",
    "altTag": "IFF48",
    "settlementFee": 0.0
  },
  {
    "productId": 158,
    "productGuid": "311c15ef-7ada-4e23-a6e7-c0c53cf3ad6c",
    "name": "Interest (7.9% APR Representative) Finance (48 Months)",
    "minLoan": 1000.0000,
    "maxLoan": 50000.0000,
    "months": 48,
    "monthlyRate": 7.90,
    "apr": 7.9,
    "serviceFee": 0.0,
    "documentFee": 0.0,
    "documentFeeCollectionMonth": 0,
    "documentFeeMaximum": 0,
    "documentFeeMinimum": 0,
    "documentFeePercentage": 0.0,
    "optionPeriod": 0,
    "deferredPeriod": 0,
    "tag": "CC48-7.9",
    "altTag": "CC48-7.9",
    "settlementFee": 0.0
  }
];


class V12Prices {
  constructor(options = {}) {
    this.settings = options.settings || {};

    this.config = {
      thirtySixMonthsAvailable: true,
      initialCashPrice: options.initialCashPrice || 0,
      shouldOpen: options.shouldOpen || false,
      displayInterest: options.displayInterest || false,
    };

    this.defaultFinanceProductId = 43;
    this.defaultDepositFactor = 0;

    this.maxDepositPercentage = 0;
    this.minDepositPercentage = 0;

    this.data = {
      financeProduct: this.defaultFinanceProductId,
      financeProducts: financeOptions,
      depositFactor: this.defaultDepositFactor,
      cashPrice: this.config.initialCashPrice,
      minimumPossibleLoanAmount: null,
      maximumPossibleLoanAmount: null,
      lowestInterestFreeLength: 0,
      costPerMonthWithNoDeposit: null,
    };

    if (!options.skipInit) {
      this.init();
    }
  }

  getLabel(key, fallback) {
    return this.settings.labels?.[key] || fallback;
  }

  getUiCopy(key, fallback) {
    return this.settings.ui?.[key] || fallback;
  }

  formatTemplate(template, vars) {
    return Object.entries(vars).reduce(
      (str, [key, value]) => str.replace(new RegExp(`\\{\\{\\s*${key}\\s*\\}\\}`, 'g'), value),
      template
    );
  }

  formatCurrency(amount) {
    const formattedAmount = parseFloat(amount).toFixed(2);
    const template = this.settings.currencyFormat || '£{{ amount }}';
    return this.formatTemplate(template, { amount: formattedAmount });
  }

  static calculateRepresentativeExample(cashPrice, depositPercent, productId, settings = {}) {
    const calc = new V12Prices({
      initialCashPrice: cashPrice,
      shouldOpen: false,
      settings,
      skipInit: true,
    });

    calc.data.depositFactor = depositPercent;
    calc.data.financeProduct = productId;
    calc.data.cashPrice = cashPrice;

    return {
      cashPrice: calc.formatCurrency(cashPrice),
      deposit: calc.formatCurrency(parseFloat(calc.getDeposit())),
      credit: calc.formatCurrency(calc.getLoanAmount()),
      loanTerm: calc.getLoanTermDisplay(),
      annualRate: calc.getAnnualRateDisplay(),
      monthlyRepayment: calc.formatCurrency(parseFloat(calc.getInitialPayments())),
      representativeApr: calc.getRepresentativeAprValue(),
      totalCostOfCredit: calc.formatCurrency(parseFloat(calc.getTotalCostOfCredit())),
      totalAmountPayable: calc.formatCurrency(parseFloat(calc.getAmountPayable())),
    };
  }

  getPlanPeriodText() {
    const months = this.getSelectedFinanceProduct()?.months || 0;
    const prefix = this.getUiCopy('planPeriodPrefix', 'every month for');
    const suffix = this.getUiCopy('planPeriodSuffix', 'months');
    return `${prefix} ${months} ${suffix}`;
  }

  async init() {
    await this.loadV12Config();

    this.data.minimumPossibleLoanAmount = this.getMinimumPossibleLoanAmount();
    this.data.maximumPossibleLoanAmount = this.getMaximumPossibleLoanAmount();
    this.getLowestMonthlyRepayment();
    this.setMaxDepositPercentage();
    this.getLowestInterestFreeLength();

    this.triggerDisplayUpdate();
  }

  async loadV12Config() {
    this.data.financeProducts = financeOptions;
  }

  triggerDisplayUpdate() {
    const event = new CustomEvent('v12CalculationsComplete', {
      detail: {
        monthlyPayment: this.data.costPerMonthWithNoDeposit,
        months: this.data.lowestInterestFreeLength
      }
    })

    document.dispatchEvent(event);
  }
  
  getLowestInterestFreeLength() {
    this.getFilteredFinanceProducts().filter(x => x.monthlyRate === 0).forEach(product => {
      if (product.months > this.data.lowestInterestFreeLength) {
        this.data.lowestInterestFreeLength = product.months;
        this.data.costPerMonthWithNoDeposit = Math.ceil((this.data.cashPrice / this.data.lowestInterestFreeLength) * 100) / 100;
      }
    });
  }
  
  getMinimumPossibleLoanAmount() {
    return this.config.initialCashPrice - (this.config.initialCashPrice / 100) * 50;
  }
  
  getMaximumPossibleLoanAmount() {
    return this.config.initialCashPrice - (this.config.initialCashPrice / 100) * 10;
  }
  
  getAprDisplay() {
    const selectedProduct = this.getSelectedFinanceProduct();
    const apr = parseFloat(selectedProduct?.apr || 0);

    if (apr === 0) {
      return this.settings.zeroAprLabel;
    }

    return this.formatTemplate(this.settings.aprRepresentative, {
      apr: apr.toFixed(1),
    });
  }

  getRepresentativeAprValue() {
    const selectedProduct = this.getSelectedFinanceProduct();
    const apr = parseFloat(selectedProduct?.apr || 0);

    if (apr === 0) {
      return this.settings.zeroAprRepresentativeLabel;
    }

    return this.getAprDisplay();
  }

  getAnnualRateDisplay() {
    const selectedProduct = this.getSelectedFinanceProduct();
    const monthlyRate = parseFloat(selectedProduct?.monthlyRate || 0);

    if (monthlyRate === 0) {
      return this.settings.zeroAprLabel;
    }

    return this.formatTemplate(this.settings.annualRatePercent, {
      rate: this.getAnnualRate(),
    });
  }

  getLoanTermDisplay() {
    const months = this.getSelectedFinanceProduct()?.months || 0;
    return this.formatTemplate(this.getUiCopy('loanTermMonths'), { count: months });
  }

  getTotalCostOfCredit() {
    return (parseFloat(this.getAmountPayable()) - parseFloat(this.data.cashPrice)).toFixed(2);
  }

  generateFinanceDetailsHtml() {
    const labels = {
      cashPrice: this.getLabel('cashPrice', 'Cash price:'),
      deposit: this.getLabel('deposit', 'Amount of deposit:'),
      amountOfCredit: this.getLabel('amountOfCredit', 'Total amount of credit:'),
      loanTerm: this.getLabel('loanTerm', 'Loan term:'),
      annualRate: this.getLabel('annualRate', 'Annual rate of interest (fixed):'),
      monthlyRepayment: this.getLabel('monthlyRepayment', 'Monthly repayment:'),
      representativeApr: this.getLabel('representativeApr', 'Representative APR:'),
      totalCostOfCredit: this.getLabel('totalCostOfCredit', 'Total cost of credit:'),
      totalAmountPayable: this.getLabel('totalAmountPayable', 'Total amount payable:'),
    };

    return `
      <div>
        <span class="label">${labels.cashPrice}</span>
        <span class="value total-cash-price">£${this.data.cashPrice}</span>
      </div>
      <div>
        <span class="label">${labels.deposit}</span>
        <span class="value total-deposit-price">£${this.getDeposit()}</span>
      </div>
      <div>
        <span class="label">${labels.amountOfCredit}</span>
        <span class="value total-credit-amount">£${this.getLoanAmount()}</span>
      </div>
      <div>
        <span class="label">${labels.loanTerm}</span>
        <span class="value total-loan-term">${this.getLoanTermDisplay()}</span>
      </div>
      <div>
        <span class="label">${labels.annualRate}</span>
        <span class="value total-annual-rate">${this.getAnnualRateDisplay()}</span>
      </div>
      <div>
        <span class="label">${labels.monthlyRepayment}</span>
        <span class="value total-monthly-repayment">£${this.getInitialPayments()}</span>
      </div>
      <div>
        <span class="label">${labels.representativeApr}</span>
        <span class="value total-representative-apr">${this.getRepresentativeAprValue()}</span>
      </div>
      <div>
        <span class="label">${labels.totalCostOfCredit}</span>
        <span class="value total-cost-of-credit">£${this.getTotalCostOfCredit()}</span>
      </div>
      <div class="v12-finance-details-row--total">
        <span class="label">${labels.totalAmountPayable}</span>
        <span class="value total-amount-payable">£${this.getAmountPayable()}</span>
      </div>
    `;
  }

  v12LearnMoreClicked() {
    this.openV12Modal();
  }

  generateHowItWorksHtml() {
    if (this.settings.showHowItWorks === false) {
      return '';
    }

    const heading = this.settings.howItWorksHeading || 'How it works';
    const steps = this.settings.howItWorksSteps || [];

    const stepsHtml = steps.map((step, index) => {
      const isLast = index === steps.length - 1;
      const descriptionHtml = step.description
        ? `<div class="v12-step-description">${step.description}</div>`
        : '<div class="v12-step-description"></div>';

      return `
        <li class="v12-step-item">
          <div class="v12-step-marker">
            <div class="v12-step-dot"></div>
            ${isLast ? '' : '<div class="v12-step-line"></div>'}
          </div>
          <div class="v12-step-content">
            <span class="v12-step-title">${step.title || ''}</span>
            ${descriptionHtml}
          </div>
        </li>
      `;
    }).join('');

    return `
      <h3 class="v12-how-it-works" role="heading" aria-level="3">${heading}</h3>

      <div class="v12-steps-container">
        <div class="v12-spacer"></div>
        <ul class="v12-steps-list">
          ${stepsHtml}
        </ul>
        <div class="v12-spacer"></div>
      </div>
    `;
  }

  openV12Modal() {
    const modal = this.createModal();
    document.body.appendChild(modal);
    modal.style.display = 'block';
    document.body.style.overflowY = 'hidden';
    
    modal.addEventListener('click', (e) => {
      if (e.target === modal || e.target.classList.contains('modal-close')) {
        this.closeModal(modal);
      }
    });
  }
  
  createModal() {
    const modal = document.createElement('div');
    modal.className = 'v12-modal';
    
    modal.innerHTML = `
      <div class="v12-modal-content">
        <div class="modal-close">
          <button class="modal-close-btn">&times;</button>
        </div>
        
        <div class="v12-modal-scroll">
          <div class="v12-logo-section">
            <div class="v12-logo">
              <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="300px" height="127px" viewBox="0 0 300 127" enable-background="new 0 0 300 127" xml:space="preserve">
                <g>
                  <rect x="141.5" fill="#0D4269" width="1" height="127"/>
                  <polygon fill="#0D4269" points="71.8,98.1 71.8,33.2 62.6,33.2 64.3,29.5 75.6,29.5 75.6,98.1  "/>
                  <g>
                    <path fill="#0D4269" d="M80.9,98.1l24.9-26.8c5.6-6.2,9.3-10.5,11.1-13.6c1.8-3.2,2.8-6.5,2.8-10c0-4.5-1.7-8.4-5.1-11.7    c-3.3-3.2-7.4-4.8-12.2-4.8c-5.1,0-9.3,1.7-12.7,5.1c-3,3.1-4.8,7.1-5.5,12.4h-3.6C81,42.7,83.1,38,87,34    c4.2-4.3,9.3-6.3,15.6-6.3c6.2,0,11,1.9,14.8,5.9c3.8,4,5.7,8.6,5.7,13.9c0,3.8-0.9,7.4-2.7,10.7c-1.9,3.4-5.6,8.2-11.1,14.2    L88.8,94.6h35.4v3.5H80.9z"/>
                  </g>
                  <polygon fill="#0D4269" points="14,29.4 9,29.4 35.7,88.3 38.2,82.9  "/>
                  <polygon fill="#0D4269" points="32,29.4 27.1,29.4 44.7,68.2 47.1,62.7  "/>
                  <polygon fill="#0D4269" points="23,29.4 18.1,29.4 40.2,78.3 42.7,72.8  "/>
                  <polygon fill="#0D4269" points="0,29.4 31,98.9 33.7,92.9 4.9,29.4  "/>
                  <polygon fill="#0D4269" points="43.9,29.4 39,29.4 37.6,32.5 40,38  "/>
                  <polygon fill="#0D4269" points="52.9,29.4 47.9,29.4 42.1,42.5 44.6,48  "/>
                  <polygon fill="#0D4269" points="46.6,52.7 49.1,58.2 61.9,29.4 57,29.4  "/>
                  <g>
                    <path fill="#0D4269" d="M167.9,43h7.3c3,0,4.6-1.2,4.6-4.3c0-3-1.6-4.3-4.6-4.3h-7.3V43z M161.2,29.3h16.4c5.5,0,8.9,3.8,8.9,8.4    c0,3.6-1.4,6.2-4.8,7.6v0.1c3.3,0.8,4.2,4.1,4.4,7.1c0.1,1.9,0.1,5.5,1.3,7.2h-6.7c-0.8-1.9-0.7-4.9-1.1-7.3    c-0.5-3.2-1.7-4.6-5.1-4.6h-6.6v11.9h-6.7V29.3z"/>
                    <path fill="#0D4269" d="M206.1,46.3c-0.5-3.1-1.9-4.6-4.8-4.6c-3.8,0-5,2.9-5.1,4.6H206.1z M196.2,50.1c0.2,3.8,2.1,5.6,5.4,5.6    c2.4,0,4.4-1.5,4.8-2.8h5.3c-1.7,5.2-5.3,7.4-10.3,7.4c-6.9,0-11.2-4.8-11.2-11.6c0-6.6,4.5-11.6,11.2-11.6    c7.5,0,11.2,6.2,10.7,13H196.2z"/>
                    <path fill="#0D4269" d="M223.4,37.7h4.5v4.1h-4.5v10.9c0,2,0.5,2.5,2.6,2.5c0.7,0,1.2,0,1.9-0.2v4.8c-1,0.2-2.3,0.2-3.6,0.2    c-3.7,0-7-0.9-7-5.3V41.8h-3.6v-4.1h3.6v-6.6h6.1V37.7z"/>
                    <path fill="#0D4269" d="M244.4,48.9c-1,0.9-3.2,0.9-5.1,1.3c-1.9,0.4-3.5,1-3.5,3.2c0,2.3,1.7,2.8,3.6,2.8c4.7,0,4.9-3.7,4.9-5.1    V48.9z M230.5,44.4c0.3-5.6,5.4-7.3,10.3-7.3c4.4,0,9.7,1,9.7,6.2v11.5c0,2,0.2,4,0.8,4.9h-6.2c-0.2-0.7-0.4-1.4-0.4-2.1    c-1.9,2-4.8,2.8-7.4,2.8c-4.1,0-7.5-2.1-7.5-6.6c0-5,3.8-6.2,7.5-6.7c3.7-0.6,7.2-0.4,7.2-2.9c0-2.5-1.8-2.9-3.9-2.9    c-2.3,0-3.7,1-3.9,3.3H230.5z"/>
                  </g>
                  <path fill="#0D4269" d="M255.4,37.7h6v22h-6V37.7z M261.3,34.3h-6v-5h6V34.3z"/>
                  <rect x="266.3" y="29.3" fill="#0D4269" width="6.1" height="30.4"/>
                  <polygon fill="#0D4269" points="161.3,67.5 180.6,67.5 180.6,70 164.2,70 164.2,81 178.8,81 178.8,83.5 164.2,83.5 164.2,98    161.3,98  "/>
                  <path fill="#0D4269" d="M183.7,76h2.7v22h-2.7V76z M183.7,67.5h2.7v4.3h-2.7V67.5z"/>
                  <g>
                    <path fill="#0D4269" d="M191.5,76h2.7v3.8h0.1c0.9-2.7,3.8-4.5,7-4.5c6.2,0,8.1,3.3,8.1,8.5V98h-2.7V84.3c0-3.8-1.2-6.7-5.6-6.7    c-4.3,0-6.8,3.3-6.9,7.5V98h-2.7V76z"/>
                    <path fill="#0D4269" d="M228.5,85.9h-0.1c-0.3,0.7-1.5,0.9-2.3,1c-4.6,0.8-10.3,0.8-10.3,5.1c0,2.7,2.4,4.3,4.9,4.3    c4.1,0,7.7-2.6,7.7-6.9V85.9z M214.2,82.8c0.3-5.2,3.8-7.4,8.9-7.4c3.9,0,8.1,1.2,8.1,7.1v11.6c0,1,0.5,1.6,1.6,1.6    c0.3,0,0.6-0.1,0.8-0.2v2.3c-0.6,0.1-1,0.2-1.8,0.2c-2.7,0-3.1-1.5-3.1-3.8h-0.1c-1.9,2.8-3.8,4.5-8.1,4.5c-4.1,0-7.3-2-7.3-6.4    c0-6.2,5.9-6.4,11.8-7.1c2.2-0.3,3.5-0.6,3.5-2.9c0-3.6-2.6-4.6-5.8-4.6c-3.3,0-5.8,1.5-5.9,5.2H214.2z"/>
                    <path fill="#0D4269" d="M236.5,76h2.6v3.8h0.1c1-2.7,3.9-4.5,7.1-4.5c6.2,0,8.1,3.3,8.1,8.5V98h-2.7V84.3c0-3.8-1.2-6.7-5.6-6.7    c-4.3,0-6.8,3.3-6.9,7.5V98h-2.6V76z"/>
                    <path fill="#0D4269" d="M274.9,82.9c-0.7-3.3-2.7-5.3-6.2-5.3c-5.2,0-7.7,4.7-7.7,9.3c0,4.7,2.6,9.4,7.7,9.4    c3.3,0,6.1-2.6,6.4-6.3h2.7c-0.7,5.3-4.2,8.5-9.1,8.5c-6.8,0-10.4-5.3-10.4-11.7c0-6.3,3.7-11.6,10.4-11.6c4.7,0,8.3,2.5,8.9,7.6    H274.9z"/>
                    <path fill="#0D4269" d="M297.3,85.4c-0.1-4-2.6-7.8-7-7.8c-4.4,0-6.8,3.9-7.3,7.8H297.3z M283,87.7c0,4,2.1,8.7,7.3,8.7    c3.9,0,6.1-2.3,6.9-5.6h2.7c-1.1,5-4,7.9-9.6,7.9c-7,0-10-5.4-10-11.7c0-5.7,3-11.6,10-11.6c7.1,0,9.9,6.2,9.7,12.3H283z"/>
                  </g>
                </g>
                </svg>
            </div>
            <h2 class="v12-main-heading">${this.settings.modalHeading || 'Pay at your own pace, from 0% APR interest'}</h2>
            <p class="v12-subtitle">${this.settings.modalSubtitle || 'Flexible finance options available with competitive rates and terms to suit your budget.'}</p>
          </div>

          <div class="v12-finance-section">
            <h3 class="v12-section-title">${this.settings.modalSectionTitle || 'Customize your plan'}</h3>
            
            <div class="v12-deposit-container">
              <div class="v12-deposit-label">${this.getUiCopy('depositLabel', 'Deposit')}</div>
              <div class="v12-deposit-display">
                <div class="v12-deposit-percentage">${this.data.depositFactor}%</div>
                <div class="v12-deposit-amount">£${this.getDeposit()} deposit</div>
              </div>
              <div class="v12-slider-container">
                <div class="v12-deposit-tooltip">
                  <span class="deposit-tooltip-text"></span>
                </div>
                <input class="v12-deposit-slider" type="range" min="0" max="50" step="1" value="${this.data.depositFactor}">
              </div>
            </div>

            <div class="v12-payment-plan-container">
              <label class="v12-payment-plan-label" for="financeSelect">${this.getUiCopy('paymentPlanLabel', 'Payment Plan')}</label>
              <select class="v12-finance-select" id="financeSelect">
                ${this.generateFinanceOptions()}
              </select>
              <div class="v12-error-message">
                ${this.getUiCopy('errorMessage', 'Please choose a different payment plan or reduce your deposit amount.')}
              </div>
            </div>

            <div class="v12-plan-cards">
              <div class="v12-plan-card selected">
                <div class="v12-plan-header">${this.settings.modalPlanHeading || 'Your selected plan'}</div>
                <div class="v12-plan-amount">£${this.getInitialPayments()}</div>
                <div class="v12-plan-period">${this.getPlanPeriodText()}</div>
                <div class="v12-plan-details">
                  <span class="v12-plan-interest">${this.getAprDisplay()}</span>
                  <span class="v12-plan-total">${this.getUiCopy('planTotalPrefix', 'Total')} £${this.getAmountPayable()}</span>
                </div>
              </div>
            </div>

            <div class="v12-finance-details">
              ${this.generateFinanceDetailsHtml()}
            </div>

            ${this.settings.showLowestRepaymentButton !== false ? `
            <div class="v12-action-buttons">
              <button class="v12-lowest-repayment-btn">${this.getUiCopy('lowestRepaymentButton', 'Show Lowest Monthly Repayment')}</button>
            </div>
            ` : ''}

            ${this.generateHowItWorksHtml()}

            <div class="v12-terms-text">
              ${this.settings.termsText || 'Available in the UK only, credit is provided subject to affordability, age and status. Minimum spend applies. <a href="/pages/payment-and-finance">Terms and conditions</a> apply.'}
            </div>

            <button class="v12-close-button">${this.getUiCopy('closeButton', 'Close')}</button>
          </div>
        </div>
      </div>
    `;

    document.body.appendChild(modal);
    this.attachModalEventListeners(modal);
    return modal;
  }

  closeModal(modal) {
    modal.classList.remove('show');

    document.body.style.overflow = '';

    setTimeout(() => {
      if (modal.parentNode) document.body.removeChild(modal);
    }, 200);
  }

  openModal() {
    if (this.config.shouldOpen) {
      this.openV12Modal();
    }
  }

  calculateApr(loan, instalment, deferred, term) {
    var result = parseFloat(0);
    var high = parseFloat(200);
    var low = parseFloat(0);
    var n, x, j, q, r, y, x, z;

    if (deferred > 1) {
      n = (term + deferred + 1);
    } else {
      n = (term + 1);
    }

    x = 1;

    while (x < 20) {
      result = (high + low) / 2;
      j = parseFloat(Math.pow((1.0000 + result / 100.0000), (1.0000 / 12.0000)));
      q = parseFloat((1.0000 / j));

      if (deferred < 1) {
        y = parseFloat((instalment * (1.0000 - Math.pow(q, n))) / (1 - q) - instalment);
        z = parseFloat(0.00);
      } else {
        y = parseFloat((instalment * (1.0000 - Math.pow(q, n - 1))) / (1 - q) - instalment);
        z = parseFloat((instalment * (1.0000 - Math.pow(q, deferred))) / (1 - q) - instalment);
      }

      if ((y - z) < loan) {
        high = result;
      } else {
        low = result;
      }

      x++;
    }

    return result;
  }

  getLowestMonthlyRepayment() {
    this.data.financeProduct = this.findLowestFinanceProduct();
  }

  setMaxDepositPercentage() {
    const selectedProduct = this.getSelectedFinanceProduct();
    if (selectedProduct) {
      console.log(selectedProduct.minLoan, this.data.cashPrice)
      
      let maxDeposit = Math.floor((1 - (selectedProduct.minLoan / this.data.cashPrice)).toPrecision(15) * 100);
      this.maxDepositPercentage = maxDeposit < 50 && maxDeposit >= 0 ? maxDeposit : maxDeposit < 0 ? 0 : 50;
      maxDeposit < 50 && maxDeposit >= 0 ? this.data.depositFactor = maxDeposit : maxDeposit < 10 ? this.data.depositFactor = 0 : this.data.depositFactor = 50;
    }
  }

  findLowestFinanceProduct() {
    this.data.depositFactor = this.defaultDepositFactor;

    var lowestMonthlyPayment = 0;
    var lowestMonthlyPaymentProductId = 0;
    var loanAmount = this.data.cashPrice - this.getDeposit();

    if (loanAmount >= 12500) {
      this.data.depositFactor = 50;
      loanAmount = this.data.cashPrice - this.getDeposit();
    }

    var initialPayments;
    const filteredProducts = this.getFilteredFinanceProducts();

    for (var i = 0; i < filteredProducts.length; i++) {
      var monthlyRate = parseFloat(filteredProducts[i].monthlyRate);
      var apr = parseFloat(filteredProducts[i].apr);
      var serviceFee = parseFloat(filteredProducts[i].serviceFee);

      var deposit = parseInt(Math.ceil(this.data.cashPrice * this.data.depositFactor)) / 100;
      deposit = parseFloat(deposit.toFixed(2));
      
      if (monthlyRate == 0) {
        initialPayments = Math.round((loanAmount / filteredProducts[i].months) * 100) / 100;
        
        if (initialPayments * filteredProducts[i].months < loanAmount) {
          initialPayments += 0.01;
        }
      } else {
        var yieldValue = Math.pow(((apr) / 100) + 1, (1.00 / 12));
        var pv = loanAmount - serviceFee;
        
        if (filteredProducts[i].deferredPeriod > 1) {
          pv = (pv * Math.pow(yieldValue, (filteredProducts[i].deferredPeriod - 1)));
        }
        
        initialPayments = Math.floor(((0 - pv / ((Math.pow(yieldValue, 0 - filteredProducts[i].months) - 1) / (yieldValue - 1)))) * 100) / 100;
      }
      
      var monthlyPayment = initialPayments;
      
      if (parseFloat(lowestMonthlyPayment) > parseFloat(monthlyPayment) || lowestMonthlyPayment == 0) {
        lowestMonthlyPayment = initialPayments;
        lowestMonthlyPaymentProductId = filteredProducts[i].productId;
      }
    }
    
    return lowestMonthlyPaymentProductId;
  }
  
  getDeposit() {
    var deposit = parseInt(Math.ceil(this.data.cashPrice * this.data.depositFactor)) / 100;
    return parseFloat(deposit).toFixed(2);
  }
  
  getFilteredFinanceProducts() {
    return this.data.financeProducts.filter(financeProduct => {
      if (!this.config.thirtySixMonthsAvailable) {
        if (financeProduct.months === 36) {
          return false;
        }
      }
      return this.data.maximumPossibleLoanAmount >= financeProduct.minLoan && 
             this.data.maximumPossibleLoanAmount <= financeProduct.maxLoan;
    });
  }
  
  getSelectedFinanceProduct() {
    return this.data.financeProducts.find(financeProduct => 
      financeProduct.productId == this.data.financeProduct
    );
  }
  
  updateCashPrice(newPrice) {
    this.data.cashPrice = newPrice;
    this.init();
  }


  updateDisplayText(element) {
    const monthlyCostSpan = element.querySelector('.v12-monthly-cost');
    const monthsSpan = element.querySelector('.v12-months');

    if (monthlyCostSpan && this.data.costPerMonthWithNoDeposit) {
      monthlyCostSpan.textContent = this.data.costPerMonthWithNoDeposit.toFixed(2);
    }

    if (monthsSpan && this.data.lowestInterestFreeLength) {
      monthsSpan.textContent = this.data.lowestInterestFreeLength;
    }
  }

  setDepositToolTip(tooltipElement, message) {
    if (message) {
      tooltipElement.querySelector('.deposit-tooltip-text').textContent = message;
      tooltipElement.classList.add('show');
    } else {
      tooltipElement.classList.remove('show');
      tooltipElement.querySelector('.deposit-tooltip-text').textContent = '';
    }
  }

  attachModalEventListeners(modal) {
    const depositSlider = modal.querySelector('.v12-deposit-slider');
    const depositDisplay = modal.querySelector('.v12-deposit-percentage');
    const depositAmount = modal.querySelector('.v12-deposit-amount');
    const financeSelect = modal.querySelector('.v12-finance-select');
    const lowestRepaymentBtn = modal.querySelector('.v12-lowest-repayment-btn');
    const depositTooltip = modal.querySelector('.v12-deposit-tooltip');
    const closeBtn = modal.querySelector('.modal-close-btn');
    const closeButton = modal.querySelector('.v12-close-button');

    closeBtn.addEventListener('click', () => this.closeModal(modal));
    closeButton.addEventListener('click', () => this.closeModal(modal));

    modal.addEventListener('click', (e) => {
      if (e.target === modal) this.closeModal(modal);
    });

    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        this.closeModal(modal);
        document.removeEventListener('keydown', handleEscape);
      }
    };
    document.addEventListener('keydown', handleEscape);

    depositSlider.addEventListener('input', (e) => {
      this.data.depositFactor = parseFloat(e.target.value);

      if(this.data.depositFactor > this.maxDepositPercentage && this.maxDepositPercentage > 0){
        this.data.depositFactor = this.maxDepositPercentage;
        depositSlider.value = this.maxDepositPercentage;
        this.setDepositToolTip(
          depositTooltip,
          this.formatTemplate(this.getUiCopy('maxDepositTooltip'), {
            percent: this.maxDepositPercentage,
          })
        );
      } else {
        this.setDepositToolTip(depositTooltip, null);
      }

      depositDisplay.textContent = `${this.data.depositFactor}%`;
      depositAmount.textContent = `£${this.getDeposit()} deposit`;
      this.updateModalCalculations(modal);
    });

    financeSelect.addEventListener('change', (e) => {
      this.data.financeProduct = parseInt(e.target.value);
      this.setMaxDepositPercentage();
      this.setDepositToolTip(depositTooltip, null);
      this.updateModalCalculations(modal);
    });

    lowestRepaymentBtn?.addEventListener('click', () => {
      this.getLowestMonthlyRepayment();
      this.setMaxDepositPercentage();

      depositSlider.value = this.data.depositFactor;
      depositDisplay.textContent = `${this.data.depositFactor}%`;
      depositAmount.textContent = `£${this.getDeposit()} deposit`;

      financeSelect.value = this.data.financeProduct;
      this.updateModalCalculations(modal);
    });
  }

  generateFinanceOptions() {
    return this.getFilteredFinanceProducts().map(product => 
      `<option value="${product.productId}" ${product.productId === this.data.financeProduct ? 'selected' : ''}>
        ${product.name}
      </option>`
    ).join('');
  }

  updateModalCalculations(modal) {
    const planAmount = modal.querySelector('.v12-plan-amount');
    const planPeriod = modal.querySelector('.v12-plan-period');
    const planInterest = modal.querySelector('.v12-plan-interest');
    const planTotal = modal.querySelector('.v12-plan-total');

    planAmount.textContent = `£${this.getInitialPayments()}`;
    planPeriod.textContent = this.getPlanPeriodText();
    planInterest.textContent = this.getAprDisplay();
    planTotal.textContent = `${this.getUiCopy('planTotalPrefix', 'Total')} £${this.getAmountPayable()}`;

    modal.querySelector('.total-cash-price').textContent = `£${this.data.cashPrice}`;
    modal.querySelector('.total-deposit-price').textContent = `£${this.getDeposit()}`;
    modal.querySelector('.total-credit-amount').textContent = `£${this.getLoanAmount()}`;
    modal.querySelector('.total-loan-term').textContent = this.getLoanTermDisplay();
    modal.querySelector('.total-annual-rate').textContent = this.getAnnualRateDisplay();
    modal.querySelector('.total-monthly-repayment').textContent = `£${this.getInitialPayments()}`;
    modal.querySelector('.total-representative-apr').textContent = this.getRepresentativeAprValue();
    modal.querySelector('.total-cost-of-credit').textContent = `£${this.getTotalCostOfCredit()}`;
    modal.querySelector('.total-amount-payable').textContent = `£${this.getAmountPayable()}`;

    modal.querySelector('.v12-deposit-percentage').textContent = `${this.data.depositFactor}%`;
    modal.querySelector('.v12-deposit-amount').textContent = `£${this.getDeposit()} deposit`;
    modal.querySelector('.v12-deposit-slider').value = this.data.depositFactor;
  }

  getLoanAmount() {
    return (this.data.cashPrice - parseFloat(this.getDeposit()));
  }

  getRepayableText() {
    const initialPayments = this.getInitialPayments();
    const finalPayment = this.getFinalPayment();
    const months = this.getSelectedFinanceProduct()?.months || 0;

    if (initialPayments !== finalPayment && finalPayment > 0) {
      return `Repayable by <span class="font-medium">${months - 1}</span> monthly repayments of <span class="font-medium">£${initialPayments}</span> and a final payment of <span class="font-medium">£${finalPayment}</span>`;
    } else {
      return `Repayable by <span class="font-medium">${months}</span> monthly repayments of <span class="font-medium">£${initialPayments}</span>`;
    }
  }

  getDocumentFeeText() {
    const documentFee = this.getDocumentFee();
    const selectedProduct = this.getSelectedFinanceProduct();
    
    if (documentFee > 0) {
      if (selectedProduct?.documentFeeCollectionMonth === 0) {
        return `An arrangement fee of <span class="font-medium">£${documentFee}</span> is payable on approval`;
      } else {
        return `An arrangement fee of <span class="font-medium">£${documentFee}</span> is payable with first instalment`;
      }
    }
    return '';
  }

  getInitialPayments() {
    const selectedProduct = this.getSelectedFinanceProduct();
    const loanAmount = parseFloat(this.getLoanAmount());
    const monthlyRate = selectedProduct?.monthlyRate || 0;
    const months = selectedProduct?.months || 0;
    const apr = selectedProduct?.apr || 0;
    const serviceFee = selectedProduct?.serviceFee || 0;

    if (monthlyRate === 0) {
      let initialPayments = Math.round((loanAmount / months) * 100) / 100;
      if (initialPayments * months < loanAmount) {
        initialPayments += 0.01;
      }
      return initialPayments.toFixed(2);
    } else {
      const yieldValue = Math.pow(((apr) / 100) + 1, (1.00 / 12));
      let pv = loanAmount - serviceFee;

      if (selectedProduct?.deferredPeriod > 1) {
        pv = (pv * Math.pow(yieldValue, (selectedProduct.deferredPeriod - 1)));
      }

      const initialPayments = Math.floor(((0 - pv / ((Math.pow(yieldValue, 0 - months) - 1) / (yieldValue - 1)))) * 100) / 100;
      return initialPayments.toFixed(2);
    }
  }

  getFinalPayment() {
    const selectedProduct = this.getSelectedFinanceProduct();
    const monthlyRate = selectedProduct?.monthlyRate || 0;
    
    if (monthlyRate === 0) {
      const loanAmount = parseFloat(this.getLoanAmount());
      const initialPayments = parseFloat(this.getInitialPayments());
      const months = selectedProduct?.months || 0;
      return (loanAmount - (initialPayments * (months - 1))).toFixed(2);
    }
    
    return this.getInitialPayments();
  }

  getDocumentFee() {
    const selectedProduct = this.getSelectedFinanceProduct();
    const loanAmount = parseFloat(this.getLoanAmount());
    
    if (!selectedProduct) return 0;

    let documentFee = selectedProduct.documentFee + (loanAmount * selectedProduct.documentFeePercentage);

    if (selectedProduct.documentFeeMinimum > 0 && documentFee < selectedProduct.documentFeeMinimum) {
      return selectedProduct.documentFeeMinimum.toFixed(2);
    }

    if (selectedProduct.documentFeeMaximum > 0 && documentFee > selectedProduct.documentFeeMaximum) {
      return selectedProduct.documentFeeMaximum.toFixed(2);
    }

    return documentFee > 0 ? documentFee.toFixed(2) : 0;
  }

  getCalculatedApr() {
    const selectedProduct = this.getSelectedFinanceProduct();
    if (!selectedProduct) return '0.00';
    
    const apr = selectedProduct.apr;
    if (Number(apr) > 0) {
      return Number(apr).toFixed(2);
    }

    const documentFee = parseFloat(this.getDocumentFee());
    const loanAmount = parseFloat(this.getLoanAmount());
    const initialPayments = parseFloat(this.getInitialPayments());
    const months = selectedProduct.months;

    if (documentFee > 0) {
      // Would need calculateAprFromIrr implementation
      return '0.00';
    }

    if (selectedProduct.monthlyRate === 0) {
      return '0.00';
    }

    return this.calculateApr((loanAmount - selectedProduct.serviceFee), initialPayments, selectedProduct.deferredPeriod, months).toFixed(2);
  }

  getAnnualRate() {
    const selectedProduct = this.getSelectedFinanceProduct();
    const loanAmount = parseFloat(this.getLoanAmount());
    const interest = parseFloat(this.getInterest());
    const months = selectedProduct?.months || 0;
    const deferredPeriod = selectedProduct?.deferredPeriod || 0;

    return (((interest / loanAmount) * 100) / ((months + deferredPeriod) / 12)).toFixed(2);
  }

  getInterest() {
    const balancePayable = this.getBalancePayable();
    const loanAmount = parseFloat(this.getLoanAmount());
    return (balancePayable - loanAmount).toFixed(2);
  }

  getBalancePayable() {
    const selectedProduct = this.getSelectedFinanceProduct();
    const monthlyRate = selectedProduct?.monthlyRate || 0;
    
    if (monthlyRate === 0) {
      return parseFloat(this.getLoanAmount());
    }

    const initialPayments = parseFloat(this.getInitialPayments());
    const months = selectedProduct?.months || 0;
    return (initialPayments * months);
  }

  getAmountPayable() {
    const balancePayable = this.getBalancePayable();
    const serviceFee = this.getSelectedFinanceProduct()?.serviceFee || 0;
    const documentFee = parseFloat(this.getDocumentFee()) || 0;
    const deposit = parseFloat(this.getDeposit());
    
    return (balancePayable + serviceFee + documentFee + deposit).toFixed(2);
  }
}

document.addEventListener('DOMContentLoaded', function() {
  const v12Elements = document.querySelectorAll('[data-v12-price]');
  
  v12Elements.forEach(element => {
    const cashPrice = parseFloat(element.dataset.cashPrice) || 0;
    const settingsScript = element.querySelector('[data-v12-settings]');
    let settings = {};

    if (settingsScript) {
      try {
        settings = JSON.parse(settingsScript.textContent);
      } catch (error) {
        console.warn('V12: unable to parse settings', error);
      }
    }

    const v12Instance = new V12Prices({
      initialCashPrice: cashPrice,
      shouldOpen: true,
      settings: settings
    });

    element.v12Instance = v12Instance;

    document.addEventListener('v12CalculationsComplete', () => {
      v12Instance.updateDisplayText(element);
    })

    element.addEventListener('click', (e) => {
      e.preventDefault();
      v12Instance.v12LearnMoreClicked();
    });
  });
});
